import GenericDB from './generic-db';

export default class AuditLogDB extends GenericDB {
  constructor() {
    super('auditLog');
  }
}
